import Image from 'next/image';

type Props = {
	size?: number;
};

export const NeuronImage = ({ size = 18 }: Props) => (
	<Image
		width={size}
		height={size}
		src="/img/neurons/gem-icon.png"
		alt="neuron image"
		quality={100}
	/>
);
